export default "__VITE_ASSET__Dky0fMen__"